export const robots = [
  {
    id: 1,
    name: 'Aman Sahu',
    username: 'aman',
    email: 'sahuaman83@gmail.com'
  },
  {
    id: 2,
    name: 'Anjali Srivastava',
    username: 'anjali',
    email: 'srivastava.anjali98@gmail.com'
  },
  {
    id: 3,
    name: 'Vipin Kashyap',
    username: 'vipin',
    email: 'ronalvipin@gmail.com'
  },
  {
    id: 4,
    name: 'Garima Bansal',
    username: 'garima',
    email: 'rockonbansal@gmail.com'
  },
  {
    id: 5,
    name: 'Murtaza Zakir',
    username: 'murtaza',
    email: 'zakir.murtaza@gmail.com'
  },
  {
    id: 6,
    name: 'Hari Prasad',
    username: 'hari',
    email: 'harip@gmail.com'
  },
  {
    id: 7,
    name: 'Khusboo Jain',
    username: 'khusboo',
    email: 'syed.khusboo34@gmail.com'
  },
  {
    id: 8,
    name: 'Mayur Chourasiya',
    username: 'mayur',
    email: 'mayurchrs@gmail.com'
  },
  {
    id: 9,
    name: 'Poonam Nishad',
    username: 'Poonam',
    email: 'nishad.poonam78@gmail.com'
  },
  {
    id: 10,
    name: 'Aman Singh Chauhan',
    username: 'aman singh',
    email: 'singhaman99@gmail.com'
  }
  
];
